import { ReactNode, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';

/**
 * Chrome around the full-screen onboarding flows: an always-available Exit button back to the
 * dashboard.
 */
export default function DemoOnboardingFlowShell({ children }: Readonly<{ children: ReactNode }>) {
    const history = useHistory();
    const queryClient = useQueryClient();

    // The real formation flow refetches the launchpad's tasks when Sign completes the application
    // task, but the demo can't e-sign, so it never reaches that call. Refetch on leaving the flow
    // instead; the launchpad caches these with staleTime: Infinity and would otherwise stay stale.
    useEffect(
        () => () => {
            queryClient.refetchQueries({ queryKey: ['operatorTasks'] });
        },
        [queryClient]
    );

    // Leaving keeps the application where it was, as the real product does: Start resumes it.
    const handleExit = () => {
        history.push('/dashboard');
    };

    return (
        <Box sx={{ position: 'relative', minHeight: '100vh' }}>
            {/* Bottom-right — clear of the top header chips/back button (the flows hide their FAB). */}
            <Button
                variant="contained"
                color="secondary"
                onClick={handleExit}
                startIcon={<CloseXIcon fontSize="small" />}
                sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: (theme) => theme.zIndex.modal + 1 }}>
                Exit
            </Button>
            {children}
        </Box>
    );
}
